export const KALENDER_HUB_PATH = "/hub/kalender";
export const KALENDER_PATH_PREFIX = "/kalender";

const SELF_PERSON_KEY_STORAGE = "tm:kalender:selfPersonKey";

/** Zuletzt bekannte „Ich“-Person für Hub-Links. */
export function readKalenderSelfPersonKey() {
  try {
    return String(sessionStorage.getItem(SELF_PERSON_KEY_STORAGE) || "").trim();
  } catch {
    return "";
  }
}

export function writeKalenderSelfPersonKey(personKey) {
  const key = String(personKey || "").trim();
  try {
    if (key) sessionStorage.setItem(SELF_PERSON_KEY_STORAGE, key);
    else sessionStorage.removeItem(SELF_PERSON_KEY_STORAGE);
  } catch {
    /* ignore */
  }
}

/**
 * Hub-Kalender-URL, optional mit Personen-Deep-Link (`persons=trainer:…`).
 * Ohne personKey: nutzt zuletzt bekannte Self-Person aus sessionStorage.
 * @param {{
 *   personKey?: string,
 *   personKeys?: string[],
 *   view?: string,
 *   layout?: string,
 *   types?: string[],
 *   includeStoredSelf?: boolean,
 * }} [opts]
 * @returns {string}
 */
export function buildKalenderHubHref(opts = {}) {
  const keys = [
    ...(Array.isArray(opts.personKeys) ? opts.personKeys : []),
    opts.personKey,
  ]
    .map((k) => String(k || "").trim())
    .filter(Boolean);
  if (!keys.length && opts.includeStoredSelf !== false) {
    const stored = readKalenderSelfPersonKey();
    if (stored) keys.push(stored);
  }
  const unique = [...new Set(keys)];
  const sp = new URLSearchParams();
  if (unique.length) sp.set("persons", unique.join(","));
  const view = String(opts.view || "").trim();
  if (view) sp.set("view", view);
  const layout = String(opts.layout || "").trim();
  if (layout) sp.set("layout", layout);
  const types = (Array.isArray(opts.types) ? opts.types : [])
    .map((t) => String(t || "").trim())
    .filter(Boolean);
  if (types.length) sp.set("types", types.join(","));
  const qs = sp.toString();
  return qs ? `${KALENDER_HUB_PATH}?${qs}` : KALENDER_HUB_PATH;
}
